import { render, staticRenderFns } from "./InstructorSection.vue?vue&type=template&id=b73bfae0&scoped=true&"
import script from "./InstructorSection.vue?vue&type=script&lang=ts&"
export * from "./InstructorSection.vue?vue&type=script&lang=ts&"
import style0 from "./InstructorSection.vue?vue&type=style&index=0&id=b73bfae0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73bfae0",
  null
  
)

export default component.exports